import { Flex } from '@servicetitan/anvil2';
import { CustomerAuthContainer } from '@servicetitan/financing-application-shared';

interface CustomerAuthStepProps {
    onCompleted: () => void;
    onBack?: () => void;
}

export const CustomerAuthStep = ({ onCompleted, onBack }: CustomerAuthStepProps) => {
    return (
        <Flex direction="column" gap="4" style={{ width: '100%' }}>
            <CustomerAuthContainer onCompleted={onCompleted} onBack={onBack ?? undefined} />
        </Flex>
    );
};
